konnyScript(function($){
    $('.prdTapWrap .tap').click(function(){
        if($(this).hasClass('active')){
            $('.prdTapWrap .prdTap').removeClass('active');
        }else{
            $('.prdTapWrap .prdTap').removeClass('active');
            $(this).addClass('active');
        }
    })

    $('.prdTapWrap .popUp dt').click(function(){
        var popUp = $(this).parent('.popUp');

        $('.prdTapWrap .prdTap').removeClass('active');
        popUp.addClass('active');
        blockBodyScroll();
    })
    $('.prdTapWrap .popUp .popBg').click(function(){
        $('.prdTapWrap .prdTap').removeClass('active');
        unblockBodyScroll();
    });

});

    function getBodyScrollbarWidth() {
        return window.innerWidth - document.documentElement.offsetWidth;
    }

    function blockBodyScroll(className = 'overflow-hidden') {
        const isBlocked = document.body.classList.contains(className);

        if (isBlocked) return;

        document.body.style.setProperty('--scrollbar-width',`${getBodyScrollbarWidth()}px`);
        document.body.classList.add(className);
    }

    function unblockBodyScroll(className = 'overflow-hidden') {
        const isBlocked = document.body.classList.contains(className);

        if (!isBlocked) return;

        document.body.style.removeProperty('--scrollbar-width');
        document.body.classList.remove(className);
    }